import { BasicProgramInformation } from '@app/catalog-common/data/http/dtos/basic-program-information';
import { BasicUserInformation } from '@app/security-common/data/http/dtos/basic-user-information';
import { Notification, PropertyChangedInformation } from '@app/shared';

@Notification({
  name: "ProjectUpdatedNotification",
})


export class ProjectUpdatedNotification {
    public projectId: string;
    public projectName: string | null;
    public projectSqlId: string;
    public thumbnailUrl: string | null;
    public program: BasicProgramInformation;
    public changes: PropertyChangedInformation[] = [];
    public createdBy: BasicUserInformation;
}